<template>
  <div class="n1">
    <h1 class="n1-title">{{ title }}</h1>
    <p class="n1-info">{{ info }}</p>

    <div class="content">
      <div class="left-wrapper">
        <div style="padding-right: 20px;">
          <div style="display: flex;">
            <div style="flex: 1">
              <span class="about-us-subject">{{ aboutUsInfo.title }}</span>
            </div>
            <div style="width:120px;">
              <tiny-button type="warning" class="about-us-more" @click="handleMore">了解释格 -></tiny-button>
            </div>
          </div>

          <div style="height: 252px;margin: 10px 0;line-height: 40px;overflow: hidden;" v-html="aboutUsInfo.detail">
          </div>

          <tiny-row :flex="true" justify="space-between">
            <tiny-col :span="3" v-for="(item,index) of content" :key="index">
              <div class="brief-icon-item">
                <div class="brief-icon-item-img"
                     :style="{backgroundImage: 'url(' + item.imgUrl +')'}"
                     :class="{ 'n1-bg-enter':  currentEnter===index ,'n1-bg-leave': currentLeave===index}"
                     @mouseenter="imgMoveStart(index)"
                     @mouseout="imgMoveEnd(index)"
                ></div>
                <div class="brief-icon-text">
                  <span class="brief-num">{{ item.num }}</span>+
                </div>
                <div class="brief-icon-text">{{ item.title }}</div>
              </div>
            </tiny-col>
          </tiny-row>
        </div>
      </div>
      <div class="right-wrapper">
        <tiny-image style="width: 400px; height: 500px;opacity: 0.8;" :src="aboutUsInfo.imgUrls"
                    fit="cover"></tiny-image>
      </div>
    </div>
  </div>
</template>

<script>
import {Layout as TinyLayout, Row as TinyRow, Col as TinyCol, Image, Button} from '@opentiny/vue'
import request from '@/utils/request'

export default {
  name: "n1",
  components: {
    TinyLayout,
    TinyRow,
    TinyCol,
    TinyImage: Image,
    TinyButton: Button,
  },
  props:['info'],
  data() {
    return {
      currentEnter: null,
      currentLeave: null,
      title: "关于我们",
      aboutUsInfo: {
        id: '',
        title: '',
        imgUrls: '',
        detail: '',
      },

      content: [],
    };
  },
  created() {
    this.queryAboutUsInfo();
  },
  methods: {
    async queryAboutUsInfo() {
      const {data} = await request.get("/outSiteMenu/queryAboutUsInfo")
      console.log(data);
      if (data.code === 200 && data.data) {
        this.aboutUsInfo = data.data;


        let cnas = {
              imgUrl: require("../assets/images/n1-1.png"),
              num: data.data.cnas,
              title: 'CNAS认可项目数'
            },
            cma = {
              imgUrl: require("../assets/images/n1-2.png"),
              num: data.data.cma,
              title: 'CMA认定项目数'
            },
            aqfsq = {
              imgUrl: require("../assets/images/n1-10.png"),
              num: data.data.aqfsq,
              title: '安全阀授权'
            },
            zszs = {
              imgUrl: require("../assets/images/n1-8.png"),
              num: data.data.zszs,
              title: '证书总数'
            }
        this.content.push(cnas, cma, aqfsq, zszs);
      }
    },


    imgMoveStart(index) {
      this.currentEnter = index;
      this.currentLeave = null;
    },
    imgMoveEnd(index) {
      this.currentLeave = index;
      this.currentEnter = null;
    },

    handleMore() {
      this.$router.push({path: '/page1' , query: {id: this.aboutUsInfo.id}});
    },


  },

};
</script>

<style scoped>
.n1 {
  text-align: center;
  margin-top: 100px;
}

h1 {
  position: relative;
  display: inline-block;
  margin: 0 auto 20px;
  line-height: 30px;
  padding: 0 30px;
  font-weight: 400;
  font-size: 28px;
}

h1::before {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_r.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  left: 100%;
}

h1::after {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_l.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  right: 100%;
}

.n1-bg {
  width: 140px;
  height: 140px;
  display: block;
  margin: auto;
  background-size: cover;
  background-position: 0 140px;
}

.n1-bg-enter {
  animation: enter 400ms steps(25) both;
}

.n1-bg-leave {
  animation: leave 400ms steps(25) both;
}

.content {
  width: 1180px;
  margin: 40px auto;
  display: flex;
  text-align: left;
}

.content .left-wrapper {
  flex: 1;

}

.content .right-wrapper {
  width: 400px;
}

.about-us-subject {
  font-size: 24px;
  color: #214B85;
  font-weight: bold;
  margin-top: 35px;
}

.about-us-more {
  background-color: #f57c00;
  border-radius: 50px;
  color: white;
}

.brief-icon-item {
  text-align: center;
}

.brief-icon-item-img {
  width: 140px;
  height: 140px;
  display: block;
  margin: auto;
  background-size: cover;
  background-position: 0 140px;
}

.brief-icon-text {
  margin-top: 10px;
  font-size: 14px;
}

.brief-num {
  font-size: 20px;
  font-weight: bold;
  margin-right: 5px;
}


@keyframes enter {
  0% {
    background-position: 0 140px;
  }
  90% {
    background-position: 0 3640px;
  }
  100% {
    background-position: 0 3640px;
  }
}

@keyframes leave {
  0% {
    background-position: 0 3640px;
  }
  90% {
    background-position: 0 140px;
  }
  100% {
    background-position: 0 140px;
  }
}

</style>


